import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { atom, useSetRecoilState } from "recoil";
import { useApi } from "../../../../hooks/useApi";
import { ICommentInfo } from "../../../../pages/Users/Comment";
import LineBtn from "../../../Button/LineBtn";
import Blank from "../../../DefaultStyles/Blank";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import CommentModal from "../../Users/UserDetail/CommentModal/CommentModal";

interface PartyDetailCommentProps {
  partyId?: string;
  ownerId: number;
}

export const partyCommentDataState = atom<null | ICommentInfo[]>({
  key: "partyCommentDataState",
  default: null,
});

export default function PartyDetailComment({
  partyId,
  ownerId,
}: PartyDetailCommentProps) {
  const navigate = useNavigate();

  const setPartyCommentData = useSetRecoilState(partyCommentDataState);
  const [page, setPage] = useState(0);
  const [commentModal, setCommentModal] = useState(false);
  const [commentData, setCommentData] = useState<ICommentInfo>({
    commentId: "",
    servsubsid: 0,
    partyId: "",
    tag: "",
    content: "",
    writeDay: "",
    writer: "",
    name: "",
    nickname: "",
    uid: "",
  });

  const { response, fetchData } = useApi({
    method: "get",
    url: `comment?page=${page}&size=5&partyid=${partyId}`,
  });

  const commentInfoHeader = [
    "NO",
    "UID_이름_닉네임",
    "등급",
    "태그(구분)",
    "내용",
    "작성 일시",
    "작성자",
    "보기",
  ];

  useEffect(() => {
    if (response?.status === 200 && response?.data?.items?.length > 0) {
      const data = response?.data?.items;
      const forcedLeaveOrExit: ICommentInfo[] = [];

      data?.forEach((d: ICommentInfo) => {
        if (d.tag?.includes("파티탈퇴_") || d.tag?.includes("파티해산_")) {
          forcedLeaveOrExit.push(d);
        }
      });

      setPartyCommentData(forcedLeaveOrExit);
    }
  }, [response]);

  return (
    <LineBox>
      <>
        <TitleWithLine title="파티 코멘트" />

        <Blank blankHeight={24} />

        <Table tableHeadData={commentInfoHeader} tableMinWidth={1020}>
          <>
            {response?.data?.items?.map((d: ICommentInfo) => {
              return (
                <TableBody key={d?.commentId}>
                  <TableBodyItem>{d?.commentId}</TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() => navigate(`/users/info/${d?.uid}`)}
                  >
                    {d?.uid}_{d?.name}_{d?.nickname}
                  </TableBodyItem>
                  <TableBodyItem>
                    {+d?.uid === ownerId ? "파티장" : "파티원"}
                  </TableBodyItem>

                  <TableBodyItem>{d?.tag}</TableBodyItem>
                  <TableBodyItem>{d?.content}</TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.writeDay)?.format("YYYY-MM-DD HH:mm:ss")}
                  </TableBodyItem>
                  <TableBodyItem>{d?.writer}</TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="보기"
                      btnClickEvent={() => {
                        setCommentData(d);
                        setCommentModal(true);
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <Pagination
          totalPage={response?.data?.totalPage ?? 1}
          currentPage={page}
          pageClickEvent={(index) => setPage(index)}
        />

        {commentModal && (
          <CommentModal
            closeEvent={() => setCommentModal(false)}
            confirmEvent={() =>
              fetchData({
                method: "get",
                url: `comment?page=${page}&size=5&partyid=${partyId}`,
              })
            }
            commentData={commentData}
            type="view"
          />
        )}
      </>
    </LineBox>
  );
}
